import type { Category, Vendor } from '../../../../types';
import { XIcon } from '../../../../components/primitives/Icon';
import { isAmenityType, AMENITY_LABELS } from '../../../../utils/amenities';
import shared from './shared.module.css';

interface Props {
  vendor: Vendor;
  category?: Category | undefined;
  onClose: () => void;
}

/** Top strip shown at the top of the detail panel — category dot + label + close.
 *  For amenity vendors the dot color and label come from the per-type token,
 *  matching the marker / list-row visual; non-amenity vendors use the
 *  Categories-tab color and name. */
export function VendorCategoryStrip({ vendor, category, onClose }: Props) {
  const catId = isAmenityType(vendor.type) ? vendor.type : category?.id;
  const stripLabel = isAmenityType(vendor.type)
    ? AMENITY_LABELS[vendor.type].toUpperCase()
    : (category?.name ?? 'Vendor').toUpperCase();
  return (
    <div className={shared.categoryStrip}>
      <span className={shared.categoryStripLabel}>
        <span
          className={shared.categoryStripDot}
          data-cat-id={catId}
        />
        {stripLabel}
      </span>
      <button
        type="button"
        className={shared.categoryStripClose}
        onClick={onClose}
        aria-label="Close vendor details"
      >
        <XIcon size={16} />
      </button>
    </div>
  );
}
